import { render, staticRenderFns } from "./RegisteredParticipants.vue?vue&type=template&id=1f6bd812"
import script from "./RegisteredParticipants.vue?vue&type=script&lang=js"
export * from "./RegisteredParticipants.vue?vue&type=script&lang=js"
import style0 from "./RegisteredParticipants.vue?vue&type=style&index=0&id=1f6bd812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports